import React, { FC } from 'react';
import { AccessDeniedView } from '../components';

export const AccessDeniedPage: FC = () => {
  return <AccessDeniedView />;
};
